import { createAction, props } from '@ngrx/store';
import { SupportOrgLogModels } from '@models/support-org-log.model';

const prefix = '[SUPPORT_ORGANIZATION]';
export const resetToInitialState = createAction(`${prefix} Reset to Initial state`);

export const beforeGetSupportOrgLogs = createAction(
  `${prefix} Before Get Support organization logs`,
  props<{
    filters: SupportOrgLogModels.RequestFilter;
  }>(),
);

export const getSupportOrgLogs = createAction(
  `${prefix} Get Support organization logs`,
  props<{
    filters: SupportOrgLogModels.RequestFilter;
  }>(),
);
export const getSupportOrgLogsSuccess = createAction(
  `${prefix} Get Support organization logs success`,
  props<{
    documents: SupportOrgLogModels.Document[];
  }>(),
);
export const getSupportOrgLogsFail = createAction(`${prefix} Get Support organization logs fail`);

export const setSupportOrgLogsLoader = createAction(
  `${prefix} Set Support Org logs loader`,
  props<{
    loading: boolean;
  }>(),
);
